var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
// styles
import "./stepper.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-stepper",
    orientation: "horizontal",
};
const Stepper = (_a) => {
    var { className, orientation, steps, activeStep } = _a, rest = __rest(_a, ["className", "orientation", "steps", "activeStep"]);
    const classList = classNames("tecma-stepper", orientation, className);
    return (_jsx("div", Object.assign({ className: classList }, rest, { children: steps.map((step, index) => (_jsxs("div", { className: "step", children: [_jsxs("div", { className: "step-index-container", children: [_jsx("div", { className: index + 1 === activeStep ? "step-index selected" : "step-index", children: index + 1 >= activeStep ? (_jsx("span", { children: index })) : (_jsx(Icon, { iconName: "check", size: "small" })) }), _jsx("div", { className: "step-index-line" })] }), _jsxs("div", { className: "step-content", children: [_jsx("p", { className: "title", children: step.title }), _jsx("p", { className: "content", children: step.content })] })] }, step.title))) })));
};
Stepper.defaultProps = defaultProps;
export default React.memo(Stepper);
